import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { RemarksComponent } from 'src/app/admin/menus/events/remarks/remarks.component';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConnectWithIncubatorEmailComponent } from '../ConnectWithIncubator-Email/connect-with-incubator-email/connect-with-incubator-email.component';

interface incub {
  id: string;
  incubatorName: string;
}
@Component({
  selector: 'app-connect-with-incubator-list',
  templateUrl: './connect-with-incubator-list.component.html',
  styleUrls: ['./connect-with-incubator-list.component.css'],
})
export class ConnectWithIncubatorListComponent implements OnInit {
  @ViewChild('input') inputElement: ElementRef<HTMLInputElement>;
  displayedColumns: string[] = [
    'index',
    'name',
    'startupName',
    'email',
    'phone',
    'purposes',
    'incubatorName',
    'message',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private listApi = environment.url + environment.connectWithIncubators;
  private nameListApi = environment.url + environment.incubatorNameList;
  formValue: FormGroup;
  /**
   * Constructor to initialize form and data source.
   * @param fb FormBuilder instance to create forms.
   * @param makeapi ApiService to handle API requests.
   * @param getdata ValueService to manage application values.
   * @param dialog MatDialog to manage dialog operations.
   */
  constructor(
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    public dialog: MatDialog
  ) {
    // Initialize the data source for the table.
    this.dataSource = new MatTableDataSource();

    // Create the form group with default values for form controls.
    this.formValue = this.fb.group({
      purpose: ['All'], // Default purpose set to 'All'.
      incubator: [0], // Default incubator ID set to 0.
    });
  }
  Supports = [
    'All',
    'Incubation Supports',
    'Workspace / Technical facilities',
    'Investment',
    'Mentorship',
    'Others',
  ];

  roleValue;
  searchVal;
  /**
   * Initializes the component by fetching the list of incubators that the user
   * has previously connected with and the list of incubator names.
   * It also sets the role value from the session storage.
   */
  ngOnInit(): void {
    // Trigger the loading indicator
    this.getdata.isVisibleSource.next(true);

    // Retrieve the user's role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Fetch the list of incubators that the user has previously connected with
    this.coiList();

    // Fetch the list of incubator names
    this.incubatorNameApi();

    // Initialize the search value
    this.searchVal = this.searchValue;
  }
  // Search code
  SupportsVal = 'All';
  searchValue: string;
  /**
   * Applies a search filter based on user input and fetches the filtered list.
   * Triggers the List API call if the search value length is either 0 or 3.
   *
   * @param event - The input event containing the search value.
   */
  applySearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchValue = filterValue;

    // Trigger the API call if search length is exactly 3 or empty
    if (this.searchValue.length === 3 || this.searchValue.length === 0) {
      // Set the search parameters
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
        searchString: this.searchValue,
        purpose: this.SupportsVal,
        incubatorId: this.incubatorVal,
      };

      // Call the API to fetch the filtered list
      this.ListApi();
    }
  }

  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 25;
  pageNumber: number = 1;
  noData = true;
  /**
   * Fetches the list of incubators and populates the table with the data.
   * Uses the current search parameters and pagination.
   * Subscribes to the API response and updates the component data.
   */
  coiList() {
    // Create the request object with the current search parameters and pagination
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      searchString: this.searchValue,
      purpose: this.SupportsVal,
      incubatorId: this.incubatorVal,
    };

    // Call the API to fetch the list of incubators
    this.ListApi();
  }
  req;
  excelval;

  /**
   * Fetches the list of incubators and populates the table with the data.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API
   */
  ListApi() {
    this.getdata.amizhthLoader('show');
    this.disList = [];
    return this.makeapi
      .method(this.listApi, this.list, 'post')
      .subscribe((data: any) => {
        this.getdata.amizhthLoader('hide');
        // If there is no data, set the noData flag to true
        if (data.count == 0) {
          this.noData = true;
        }
        // If there is data, set the noData flag to false and update the component data
        else {
          this.noData = false;
          // Set the total count of incubators
          this.pageTotalCount = data.count;
          // Set the list of incubators to be displayed
          this.disList = data.incubatorConnectList;
          // Set the MatTableDataSource with the list of incubators
          this.dataSource = new MatTableDataSource(data.incubatorConnectList);
        }
      });
  }
  sam;
  /**
   * Initializes the paginator after the component view has been initialized.
   * Called after the component's view has been fully initialized.
   * Sets the paginator for the MatTableDataSource.
   */
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  /**
   * Handles the pagination event and updates the list parameters.
   * Resets the paginator and page number if applicable, and fetches the updated list.
   *
   * @param event - The pagination event containing the page index and page size.
   */
  getServerData(event): void {
    // Reset the search input value if applicable
    if (this.inputElement && this.inputElement.nativeElement) {
      this.inputElement.nativeElement.value = '';
    }
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;

    // Create the request parameters for the API call
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      searchString: this.searchValue,
      purpose: this.SupportsVal,
      incubatorId: this.incubatorVal,
    };
    // Call the API to fetch the updated list
    this.ListApi();
  }

  /**
   * Handles the selection of an option and updates the list parameters.
   * Resets the paginator and page number if applicable, and fetches the updated list.
   *
   * @param option - The selected option value that updates the SupportsVal.
   */
  onSelect(option) {
    // Update the SupportsVal with the selected option
    this.SupportsVal = option;

    // Reset the paginator and page number if the paginator is defined
    if (this.paginator != undefined) {
      this.paginator.pageIndex = 0;
      this.pageNumber = 1;
    }

    // Update the list parameters with the current values
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      searchString: this.searchValue,
      purpose: this.SupportsVal,
      incubatorId: this.incubatorVal,
    };

    // Fetch the updated list from the API
    this.ListApi();
  }
  /**
   * Opens a dialog to view the description details.
   * @param status - The status associated with the description.
   * @param title - The title of the description.
   */
  viewDescrptionBtn(status, title) {
    // Open the RemarksComponent dialog with the provided status and title
    const dialogRef = this.dialog.open(RemarksComponent, {
      width: '390px',
      data: { _status: status, _title: title },
    });

    // After the dialog is closed, perform any necessary actions
    dialogRef.afterClosed().subscribe((result) => {
      // Handle any logic after the dialog is closed
    });
  }
  /**
   * Opens a modal dialog for connecting with incubators.
   * The modal dialog takes the current search value and list of incubators as input.
   * The modal dialog is opened with a width of 700px and a height of 280px.
   */
  openModal() {
    // If the search value is undefined, set it to an empty string.
    if (this.searchValue == undefined) {
      this.searchValue = '';
    }
    // Open the modal dialog with the list of incubators as data.
    const dialogRef = this.dialog.open(ConnectWithIncubatorEmailComponent, {
      width: '700px',
      height: '280px',
      data: { _key: this.list },
    });
    // Subscribe to the afterClosed event to handle the result of the modal dialog.
    dialogRef.afterClosed().subscribe((result) => {});
  }
  protected incubatorNameList: incub[] = [];
  /**
   * Retrieves the list of incubators from the server.
   * The list of incubators is saved in the `incubatorNameList` property.
   * The `filterIncubetor` method is called to set the initial value of the
   * incubator name select control.
   */
  incubatorNameApi() {
    this.makeapi
      .method(this.nameListApi, '', 'postunauth')
      .subscribe((data) => {
        // Save the list of incubators
        this.incubatorNameList = data;
        // Set the initial value of the incubator name select control
        this.filterIncubetor();
      });
  }

  public incubatorName: FormControl = new FormControl();
  public incubatorFilterCtrl: FormControl = new FormControl();
  public incubatorListValue = new ReplaySubject(1);
  protected _onDestroy = new Subject();
  /**
   * Filters the list of incubators based on the user's input.
   * Sets the initial value of the incubator name select control and filters the list
   * of incubators based on the user's input.
   * Subscribes to the value changes of the filter control and calls the
   * filterBanks function whenever the value changes.
   */
  filterIncubetor() {
    // Set the initial value of the incubator name select control
    this.incubatorName.setValue(this.incubatorNameList[1]);

    // Set the initial value of the incubator list
    this.incubatorListValue.next(this.incubatorNameList.slice());

    // Subscribe to the value changes of the filter control
    this.incubatorFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        // Call the filterBanks function whenever the value of the filter control changes
        this.filterBanks();
      });
  }
  /**
   * Filters the list of incubators based on the search term entered by the user.
   * If no search term is entered, the entire list of incubators is returned.
   * Otherwise, the list is filtered to include only incubators whose name
   * contains the search term.
   */
  protected filterBanks() {
    const search = this.incubatorFilterCtrl.value;
    if (!search) {
      // If no search term is entered, return the entire list of incubators
      this.incubatorListValue.next(this.incubatorNameList.slice());
    } else {
      // Convert the search term to lowercase for case-insensitive comparison
      const lowerSearch = search.toLowerCase();
      // Filter the list of incubators to include only those whose name contains
      // the search term
      this.incubatorListValue.next(
        this.incubatorNameList.filter(
          (val) => val.incubatorName.toLowerCase().indexOf(lowerSearch) > -1
        )
      );
    }
  }
  searchValues = false;
  searchList = [];
  incubatorID;
  incubatorVal = 0;
  /**
   * Handles the selection of an incubator from the dropdown.
   * If the incubator is selected, the list of incubators is updated with the selected incubator.
   * @param value The selected incubator ID.
   */
  selectIncubator(value) {
    // Set the search values flag to true
    this.searchValues = true;

    // Clear the search list
    this.searchList = [];

    // Set the selected incubator ID
    this.incubatorID = this.formValue.value;

    // Set the selected incubator value
    this.incubatorVal = value;

    // Set the list parameters
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      searchString: this.searchValue,
      purpose: this.SupportsVal,
      incubatorId: this.incubatorVal,
    };

    // Call the List API to fetch the updated list of incubators
    this.ListApi();
  }
}
